<template>
<v-autocomplete v-model="model" :items="items" :loading="loading" :search-input.sync="search" :label=label :placeholder=placeholder :hint="hint" :hide-details="hideDetails" item-value="id" item-text="name.ro" :menu-props="{transition:'scale-transition'}"
    persistent-hint clearable flat solo return-object no-filter>

    <template slot="selection" slot-scope="data">
        {{data.item.name.ro}}
    </template>

    <template slot="item" slot-scope="data">
        {{data.item.name.ro}}
    </template>

</v-autocomplete>
</template>

<script>
export default {

    name: `place-search`,

    props: {
        organization: Object,
        label: String,
        placeholder: String,
        hint: String,
        hideDetails: Boolean
    },

    data() {
        return {
            model: {
                name: {
                    ro: ""
                },
                region: {
                    ro: ""
                },
                country: "",
                type: "",
                timezone: "",
                hits: "",
                priority: "",
                search_text: "",
                geometry: {
                    location: {
                        lat: 0,
                        lng: 0
                    },
                    viewport: {
                        northeast: {
                            lat: 0,
                            lng: 0
                        },
                        southwest: {
                            lat: 0,
                            lng: 0
                        }
                    }
                }
            },
            items: [],
            loading: false,
            search: null
        }
    },

    watch: {

        search(val) {

            if(this.model && val === this.model.name.ro) {
                return;
            }

            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit('input', this.model);
        },

        place(val) {
            this.model = {
                id: val.id,
                name: val.name,
                type: val.type,
            };

            if(val.id && val.name && val.type) {
                this.items = [this.model]
            } else {
                this.items = [];
            }

        },

    },

    methods: {

        getItems(val) {
            // quit early if no search value
            if(!val) {
                return
            }

            // we are currently loading
            this.loading = true;

            // setup query params
            let params = {
                params: {
                    search: val,
                    fields: ['search_text'],
                    size: 5
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/places";

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    this.emitError("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

    }

}
</script>
